import { Logement } from './logement.model';

/** Aligné sur {@code fr.gavicyconseil.dto.LocataireDto} (MVP occupation). */
export class Locataire {
  idLocataireDto!: string;
  civiliteDto?: string;
  nomDto!: string;
  prenomDto!: string;
  telephoneDto!: string;
  mailDto?: string;
  dateNaissanceDto?: Date | string;
  villeNaissanceDto?: string;
  logementDto?: Logement;
  /** Lien optionnel vers le contact d'origine. */
  idContactDto?: string;
  dateEntreeDto?: Date | string;
  dateBailDto?: Date | string;
  dateSortieDto?: Date | string;
  dateClesDto?: Date | string;
  dureeBailDto?: string;
  /** Locataire étudiant. */
  etudiantDto = false;
  activeDto = true;
  /** Alerte non bloquante densite / surface (renseignee par l'API). */
  densiteAlerteDto?: boolean;
  /**
   * Suppression physique possible (bail non signé, aucun loyer versé).
   * Renseigné par l'API, non persisté.
   */
  suppressionDefinitivePossibleDto?: boolean;
}
